import CreateNewPasswordPage from "./CreateNewPasswordPage";

export default CreateNewPasswordPage;